#import "../fragments/products-mutation-fragment.graphql"

mutation UpdateProductForLead($input: LeadProductUpdateInput!) {
    leadProductUpdate(input: $input) {
        lead {
            ...ProductMutationFragment
        }
    }
}
